<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="700px"
    id="evaluation"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
  >
    <el-result icon="success" title="确认成功" subTitle></el-result>
    <div class="evaContent">我们真诚地邀请您对我们的对接服务进行评价，以便我们改进，提供更好服务</div>
    <el-form ref="form" v-loading="detailLoading" :model="form" label-width="250px" label-position="left">
      <el-form-item label="您认为工作人员的专业性如何？" prop="specialityStatus">
        <el-rate v-model="form.specialityStatus"></el-rate>
      </el-form-item>
      <el-form-item label="工作人员的回复速度是否及时？" prop="timelinessStatus">
        <el-rate v-model="form.timelinessStatus"></el-rate>
      </el-form-item>
      <el-form-item label="您认为工作人员的服务态度如何？" prop="serviceAttitudeStatus">
        <el-rate v-model="form.serviceAttitudeStatus"></el-rate>
      </el-form-item>
      <div class="desc" v-show="showDesc">感谢您的反馈，我们将尽快安排客服与您联系，妥善处理相关问题</div>
      <el-form-item label="备注" prop="evaluationRemark" label-width="80px">
        <el-input type="textarea" :rows="4" v-model="form.evaluationRemark"></el-input>
      </el-form-item>
      <el-form-item label="附件" label-width="80px">
        <el-upload
          ref="upload"
          multiple
          :action="action"
          :limit="3"
          :before-upload="beforeUpload"
          :on-success="uploadFile"
          :on-remove="removeFile"
          :on-exceed="exceed"
          >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="footerBox">
      <el-button
        type="primary"
        size="small"
        style="width: 80px"
        plain
        @click="close"
      >取消</el-button>
      <el-button
        type="primary"
        size="small"
        style="width: 80px"
        @click="submitHandle()"
        :disabled="detailLoading"
        v-preventClick
      >确认评价</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { orderEvaluation, orderInfo } from "@/api/request";
import { getToken } from "@/plugins/auth";

export default {
  data() {
    return {
      dialogVisible: false,
      detailLoading: false,
      action: process.env.VUE_APP_BASE_API + "/file/upload", // 上传的图片服务器地址
      fileList: [],
      countList: ['3.5', '4', '4.5', '5', '5.5'],
      form: {
        orderId: '',
        evaluateStatus: 2,
        specialityStatus: 3,
        timelinessStatus: 3,
        serviceAttitudeStatus: 3,
        evaluationRemark: "",
        evaluateList: [],
      }
    };
  },
  computed: {
		showDesc() {
			return (this.form.specialityStatus <= 3 || this.form.timelinessStatus <= 3 || this.form.serviceAttitudeStatus <= 3)
		}
	},
  methods: {
    // 根据订单详情回显三个评价星级；详情无评分时默认两颗星。
    async init(info) {
      this.dialogVisible = true;
      this.detailLoading = true;
      await this.$nextTick();
      this.$refs.form.resetFields();
      this.form.orderId = info.orderId;
      try {
        const res = await orderInfo(info.orderId);
        ["specialityStatus", "timelinessStatus", "serviceAttitudeStatus", "evaluationRemark"].forEach(field => {
          const index = this.countList.findIndex(value => Number(value) === Number(res.data[field]));
          this.form[field] = index === -1 ? 3 : index + 1;
        });
      } catch (error) {
        this.$message.error("订单详情获取失败，请重试");
        this.close();
      } finally {
        this.detailLoading = false;
      }
    },
    submitHandle() {
			const data = {
				...this.form,
				specialityStatus: this.countList[this.form.specialityStatus - 1],
				timelinessStatus: this.countList[this.form.timelinessStatus - 1],
				serviceAttitudeStatus: this.countList[this.form.serviceAttitudeStatus - 1],
			}
      this.$refs.form.validate(async valid => {
        if (valid) {
          await orderEvaluation(data)
          this.$message.success("操作成功");
          this.close();
        }
      })
    },
    close() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    beforeUpload(file) {
      const typeList = ['image/jpeg', 'image/png', 'image/jpg']
      if (!typeList.includes(file.type)) {
        this.$message.error("只能上传JPG/PNG格式!");
        return false;
      }
      if(this.fileList.find(item => item.name == file.name)) {
        this.$message.error('请不要上传重复附件', 2)
        return false
      }
      return true;
    },
    uploadFile(res, file) {
      const obj_1 = {
        name: res.data.name,
        url: res.data.url
      }
      const obj_2 = {
        name: res.data.name,
        url: process.env.VUE_APP_FILE_API + res.data.url
      }
      this.form.evaluateList.push(obj_1)
      this.fileList.push(obj_2)
    },
    removeFile(file, fileList) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
      this.form.evaluateList = this.form.evaluateList.filter(item => item.name !== file.name);
    },
    exceed() {
      this.$message.error("只能上传3张图片！");
    },
    closeDialog() {
      this.form.evaluateList = []
      this.fileList = []
      this.$refs.upload.clearFiles()
    },
  }
};
</script>
<style>
#evaluation .el-result {
  padding: 0;
}
#evaluation .el-dialog__body {
  padding: 0 50px;
}
#evaluation .el-form-item {
    margin-bottom: 5px;
}
</style>
<style scoped lang="scss">
.evaContent {
    font-size: 15px;
  font-weight: 500;
  line-height: 40px;
}
.desc {
	margin-bottom: 15px;
	color: #FF4A2B;
}
</style>

